var RNDBModel = require('./wrappers/react-native-db-models')
var DB = {
    table : function(tableName)
    {
      if( typeof DB[tableName] === 'undefined' ) DB[tableName] = new RNDBModel.create_db(tableName);

      return DB[tableName];
    },
}
module.exports = DB



// WEBPACK FOOTER //
// ./src/DB.js